"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import { ChangelogTags } from "@/components/changelog-tags";
import { changelogPageSize, changelogPath, changelogProducts, changelogTags } from "@/lib/changelog";
import { formatNumber } from "@llmgateway/shared/number-format";
import type { ChangelogTag } from "@/lib/changelog";
import type { ChangelogFrontmatter } from "@/lib/utils/markdown";
interface ChangelogProps {
  entries: ChangelogFrontmatter[];
  tag?: ChangelogTag;
  page: number;
}
export function Changelog(t0) {
  const $ = _c(54);
  const {
    entries,
    tag,
    page
  } = t0;
  const [visiblePage, setVisiblePage] = useState(page);
  const start = (page - 1) * changelogPageSize;
  const end = visiblePage * changelogPageSize;
  let hasMore;
  let t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== end || $[1] !== entries || $[2] !== page || $[3] !== start || $[4] !== tag) {
    const changelogEntries = entries.slice(start, end);
    hasMore = end < entries.length;
    t10 = "bg-background text-foreground min-h-screen font-sans pt-30";
    t6 = "container mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24";
    const t11 = tag ? `${changelogProducts[tag].name} changelog` : "Changelog";
    let t12;
    if ($[16] !== t11) {
      t12 = <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4"><h1 className="text-4xl md:text-5xl font-bold tracking-tight text-foreground">{t11}</h1></div>;
      $[16] = t11;
      $[17] = t12;
    } else {
      t12 = $[17];
    }
    const t13 = tag ? changelogProducts[tag].description : "The latest features, improvements, and fixes across LLM Gateway, DevPass, Lounge, and Airside.";
    let t14;
    if ($[18] !== t13) {
      t14 = <p className="text-muted-foreground">{t13}</p>;
      $[18] = t13;
      $[19] = t14;
    } else {
      t14 = $[19];
    }
    let t15;
    if ($[20] !== tag) {
      t15 = <nav aria-label="Filter changelog by product" className="mt-8 flex flex-wrap gap-2">{[undefined, ...changelogTags].map(product => <Link key={product ?? "all"} href={changelogPath(product)} aria-current={product === tag ? "page" : undefined} className={`inline-flex min-h-11 items-center rounded-full border px-4 py-2 text-sm font-medium transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring ${product === tag ? "border-foreground bg-foreground text-background" : "border-border text-muted-foreground hover:bg-muted hover:text-foreground"}`}>{product ? changelogProducts[product].name : "All products"}</Link>)}</nav>;
      $[20] = tag;
      $[21] = t15;
    } else {
      t15 = $[21];
    }
    if ($[22] !== t12 || $[23] !== t14 || $[24] !== t15) {
      t7 = <div className="mb-12 md:mb-16">{t12}{t14}{t15}</div>;
      $[22] = t12;
      $[23] = t14;
      $[24] = t15;
      $[25] = t7;
    } else {
      t7 = $[25];
    }
    if ($[26] !== page || $[27] !== tag) {
      t8 = page > 1 && <Link href={changelogPath(tag, page - 1)} className="mb-8 block text-sm text-muted-foreground hover:text-foreground">← Newer updates</Link>;
      $[26] = page;
      $[27] = tag;
      $[28] = t8;
    } else {
      t8 = $[28];
    }
    t9 = <div className="space-y-16 max-w-5xl mx-auto">{changelogEntries.map(_temp)}</div>;
    t5 = "mt-16 flex flex-col items-center gap-4";
    t1 = "status";
    t2 = "text-sm text-muted-foreground";
    t3 = "Showing ";
    t4 = formatNumber(changelogEntries.length);
    $[0] = end;
    $[1] = entries;
    $[2] = page;
    $[3] = start;
    $[4] = tag;
    $[5] = hasMore;
    $[6] = t1;
    $[7] = t10;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    hasMore = $[5];
    t1 = $[6];
    t10 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  let t11;
  if ($[29] !== entries.length) {
    t11 = formatNumber(entries.length);
    $[29] = entries.length;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t1 || $[32] !== t11 || $[33] !== t2 || $[34] !== t3 || $[35] !== t4) {
    t12 = <p role={t1} className={t2}>{t3}{t4} of{" "}{t11} updates</p>;
    $[31] = t1;
    $[32] = t11;
    $[33] = t2;
    $[34] = t3;
    $[35] = t4;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== hasMore || $[38] !== tag || $[39] !== visiblePage) {
    t13 = hasMore && <Link href={changelogPath(tag, visiblePage + 1)} prefetch={false} scroll={false} onNavigate={event => {
      event.preventDefault();
      setVisiblePage(_temp2);
    }} className="inline-flex min-h-11 items-center justify-center rounded-full border border-border px-6 py-2 text-sm font-medium transition-colors hover:bg-muted focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring">Load more</Link>;
    $[37] = hasMore;
    $[38] = tag;
    $[39] = visiblePage;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== t12 || $[42] !== t13 || $[43] !== t5) {
    t14 = <div className={t5}>{t12}{t13}</div>;
    $[41] = t12;
    $[42] = t13;
    $[43] = t5;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  let t15;
  if ($[45] !== t14 || $[46] !== t6 || $[47] !== t7 || $[48] !== t8 || $[49] !== t9) {
    t15 = <main className={t6}>{t7}{t8}{t9}{t14}</main>;
    $[45] = t14;
    $[46] = t6;
    $[47] = t7;
    $[48] = t8;
    $[49] = t9;
    $[50] = t15;
  } else {
    t15 = $[50];
  }
  let t16;
  if ($[51] !== t10 || $[52] !== t15) {
    t16 = <div className={t10}>{t15}</div>;
    $[51] = t10;
    $[52] = t15;
    $[53] = t16;
  } else {
    t16 = $[53];
  }
  return t16;
}
function _temp2(current) {
  return current + 1;
}
function _temp(entry, index) {
  return <article key={entry.slug} className="grid md:grid-cols-[150px_1fr] gap-x-8 gap-y-4"><div className="md:sticky md:top-24 md:self-start z-20 bg-background/80 backdrop-blur supports-backdrop-blur:bg-background/60"><time dateTime={entry.date} className="block text-sm text-muted-foreground md:text-right pt-1">{new Date(entry.date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
          timeZone: "UTC"
        })}</time></div><div className="space-y-8"><div className="space-y-4"><ChangelogTags tags={entry.tags} /><h2 className="text-2xl font-medium text-foreground hover:text-muted-foreground transition-colors"><Link href={`/changelog/${entry.slug}`} prefetch={false}>{entry.title}</Link></h2><p className="text-muted-foreground leading-relaxed">{entry.summary}</p><Link href={`/changelog/${entry.slug}`} className="text-sm text-primary hover:text-primary/80" prefetch={false}>Read more<span className="sr-only"> about {entry.title}</span> →</Link></div><div className="bg-card border border-border rounded-lg overflow-hidden"><Link href={`/changelog/${entry.slug}`} prefetch={false}><Image loading={index === 0 ? "eager" : "lazy"} sizes="(min-width: 1024px) 846px, (min-width: 768px) calc(100vw - 230px), calc(100vw - 32px)" src={entry.image.src} alt={entry.image.alt} width={entry.image.width} height={entry.image.height} className="w-full h-64 object-cover hover:opacity-90 transition-opacity rounded-lg object-top" /></Link></div></div></article>;
}